"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridRow = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var utilities_1 = require("../../utilities");
var GridRow = function (_a) {
    var _b;
    var centered = _a.centered, children = _a.children, className = _a.className, _c = _a.el, TagName = _c === void 0 ? 'div' : _c, columns = _a.columns, divided = _a.divided, only = _a.only, reversed = _a.reversed, stretched = _a.stretched, textAlign = _a.textAlign, verticalAlign = _a.verticalAlign, props = __rest(_a, ["centered", "children", "className", "el", "columns", "divided", "only", "reversed", "stretched", "textAlign", "verticalAlign"]);
    // Composing classes out of "reversed" prop
    var reversedSet = new Set(typeof reversed === 'string'
        ? reversed.trim().split(' ').filter(Boolean)
        : []);
    var reversedClasses = ['mobile', 'tablet', 'desktop']
        .filter(function (device) { return reversedSet.has(device); })
        .map(function (device) {
        return reversedSet.has('vertically')
            ? "GridRow--" + device + "-vertically-reversed"
            : "GridRow--" + device + "-reversed";
    });
    var GridRowClasses = classnames_1.default('GridRow', className, reversedClasses, (_b = {
            'GridRow--centered': centered
        },
        _b["GridRow--" + utilities_1.columnsToNumeral(columns) + "-columns"] = utilities_1.columnsToNumeral(columns),
        _b['GridRow--equal-width'] = columns === 'equal',
        _b['GridRow--divided'] = divided,
        _b["GridRow--" + only + "-only"] = only,
        _b['GridRow--stretched'] = stretched,
        _b["GridRow--text-align-" + textAlign] = textAlign,
        _b["GridRow--vertical-align-" + verticalAlign] = verticalAlign,
        _b));
    return (react_1.default.createElement(TagName, __assign({ className: GridRowClasses }, props), children));
};
exports.GridRow = GridRow;
//# sourceMappingURL=GridRow.js.map